const INITIAL_STATE = {
  // triiderUser: JSON.parse(localStorage.getItem('triiderUser')),
  loading: false,
  isPassword: false,
  triiderUser: {},
  isOpenModalEmail: false,
  haveAccount: false,
};

// REQUEST -> SAGA -> CHAMADA API -> REDUCER -> SUCCESS

/**
 * Types
 */
export const Types = {
  GET_USER_BY_HASH_REQUEST: 'auth/GET_USER_BY_HASH_REQUEST',
  GET_USER_BY_HASH_SUCCESS: 'auth/GET_USER_BY_HASH_SUCCESS',
  OPEN_MODAL_EMAIL: 'auth/OPEN_MODAL_EMAIL',
  UPDATE_USER_ORIGIN: 'auth/UPDATE_USER_ORIGIN',
  UPDATE_TRIIDER_USER: 'auth/UPDATE_TRIIDER_USER',
  UPDATE_TRIIDER_HAVE_ACCOUNT: 'auth/UPDATE_HAVE_ACCOUNT',
  UPDATE_USER_LOGIN: 'auth/UPDATE_USER_LOGIN',
  FETCH_TRIIDER_USER: 'auth/FETCH_TRIIDER_USER',
};

/**
 * Reducer
 */
export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_USER_BY_HASH_SUCCESS:
      return { ...state, triiderUser: action.payload };
    case Types.UPDATE_USER_ORIGIN:
      return {
        ...state,
        triiderUser: {
          ...state.triiderUser,
          user: {
            ...state.user,
            origin_id: action.payload,
          },
        },
      };
    case Types.OPEN_MODAL_EMAIL:
      return { ...state, isOpenModalEmail: action.payload };
    case Types.UPDATE_TRIIDER_HAVE_ACCOUNT:
      return { ...state, haveAccount: action.payload };
    case Types.FETCH_TRIIDER_USER:
      return { ...state, triiderUser: action.payload };
    default:
      return state;
  }
}

/**
 * Helpers
 */
// eslint-disable-next-line max-len
export const isUserAuth = triiderUser => !!(triiderUser && triiderUser.token);
export const getTriiderUser = (state) => {
  if (state.auth.triiderUser && state.auth.triiderUser.token) {
    return state.auth.triiderUser;
  }
  return {};
};

export const getTokenUser = state => state.auth.triiderUser && state.auth.triiderUser.token;

/**
 * Actions Creators
 */
export const Creators = {
  getUserByHashRequest: payload => ({
    type: Types.GET_USER_BY_HASH_REQUEST,
    payload,
  }),
  getUserByHashSuccess: payload => ({
    type: Types.GET_USER_BY_HASH_SUCCESS,
    payload,
  }),
  updateUserOrigin: payload => ({
    type: Types.UPDATE_USER_ORIGIN,
    payload,
  }),

  setModalEmail: payload => ({
    type: Types.OPEN_MODAL_EMAIL,
    payload,
  }),

  updateTriiderUser: payload => ({
    type: Types.UPDATE_TRIIDER_USER,
    payload,
  }),

  setHaveAccount: payload => ({
    type: Types.UPDATE_TRIIDER_HAVE_ACCOUNT,
    payload,
  }),

  updateUserLogin: payload => ({
    type: Types.UPDATE_USER_LOGIN,
    payload,
  }),

  fetchTriiderUser: payload => ({
    type: Types.FETCH_TRIIDER_USER,
    payload,
  }),
};
